'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _AlertOutlined = require('./lib/icons/AlertOutlined');
  
  
  var _default = _AlertOutlined;
  exports.default = _default;
  module.exports = _default;